import { FileDTO } from "./upload-documents.model";


export class UploadDocuments {
  static readonly type = '[Document] Upload Documents';
  constructor(public files: FileDTO[], public leadId: string) {}
}
